import React, { useState, useEffect } from 'react';
import './DriverSegmentationPage.css';
import DriversSegmentation from '../../components/DriversSegmentation/DriversSegmentation';
import DriverScoreCategoryPage from '../DriverScoreCategoryPage/DriverScoreCategoryPage';
import { getVehicleTypes } from '../../api/apiClient';
import tooltipTexts from '../../utils/tooltipTexts';

function DriverSegmentationPage() {
  const [selectedVehicleId, setSelectedVehicleId] = useState('');
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [vehicleError, setVehicleError] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.locationId) {
      fetchVehicleTypes(user.locationId);
    } else {
      setIsLoading(false);
      setVehicleError('No location ID found for admin');
      console.error('No location ID found for admin');
    }
  }, []);

  const fetchVehicleTypes = async (locationId) => {
    setIsLoading(true);
    setVehicleError(null);
    setVehicleTypes([]);

    try {
      const data = await getVehicleTypes(locationId);

      if (data.length === 0) {
        setVehicleError('No vehicles available for your location');
      } else {
        setVehicleTypes(data);
        if (data.length > 0) {
          setSelectedVehicleId(data[0].VehicleID.toString());
        }
      }
    } catch (error) {
      console.error('Error fetching vehicle types:', error);
      setVehicleError('Failed to load vehicles for your location');
    } finally {
      setIsLoading(false);
    }
  };

  const handleVehicleChange = (e) => {
    setSelectedVehicleId(e.target.value);
  };

  return (
    <div className="driver-segmentation-content">
      <div className="page-title">
        <h2>
          Driver Segmentation
          <span className="header-tooltip">
            <span className="info-icon">i</span>
            <span className="tooltip-text">{tooltipTexts.driverSegmentationHeader}</span>
          </span>
        </h2>
        <div className="equipment-dropdown-container">
          <span className="dropdown-label">Equipment</span>
          <div className="equipment-dropdown">
            <select
              id="vehicle-select"
              value={selectedVehicleId}
              onChange={handleVehicleChange}
              disabled={isLoading}
              className="vehicle-select"
              aria-label="Select equipment"
            >
              {isLoading ? (
                <option>Loading...</option>
              ) : vehicleError ? (
                <option value="">{vehicleError}</option>
              ) : vehicleTypes.length === 0 ? (
                <option value="">No equipment available</option>
              ) : (
                vehicleTypes.map((vehicle) => (
                  <option key={vehicle.VehicleID} value={vehicle.VehicleID.toString()}>
                    {vehicle.ScreenName || vehicle.VehicleName || `Vehicle ${vehicle.VehicleID}`}
                  </option>
                ))
              )}
            </select>
          </div>
        </div>
      </div>

      <section className="segmentation-section">
        <div className="segmentation-container">
          <DriversSegmentation vehicleId={selectedVehicleId} disableNavigation={true} />
        </div>
      </section>

      <section className="score-category-section">
        <div className="score-category-panel">
          <DriverScoreCategoryPage vehicleId={selectedVehicleId} embedded={true} />
        </div>
      </section>
    </div>
  );
}

export default DriverSegmentationPage;
